import useComputed from '@/hooks/use-computed'
import api from '@/services/api/licenseKeys.js'
import { useState } from 'react'

const useLicenseKey = (subscriptionsId) => {

	const [items, setItems] = useComputed([])

	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [errorMsg, setErrorMsg] = useState()

	async function findOne(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.findOne({
			params
		})

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}

		return data
	}
	async function getOne(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.getOne({
			params
		})

		setLoading(false)

		if (error) {
			return setErrorMsg(error);
		}

		return data
	}



	return {
		error:errorMsg,
		setErrorMsg,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		findOne,
		getOne,

	}

}

export default useLicenseKey;
